import React from 'react'
import { isNil } from 'lodash'
import i18n from '../../../simple-react-i18n'
import { Grid2 } from '@mui/material'
import Input from '../../../components/forms/Input'
import SimpleDatePicker from '../../../components/forms/SimpleDatePicker'
import { ButtonMUI } from '../../../components/styled/Buttons'
import PropTypes from 'prop-types'
import DtoStation from '../../../station/dto/DtoStation'

const CEMAGREF_ExportPanel = ({
    onChange = () => {},
    onChangeFilter = () => {},
    onApplyExport = () => {},
    selectedStations = [],
    tmpFilter = {},
}) => {


    return (
        <fieldset>
            <legend className='italic-label padding-right-1 padding-left-1'>{ i18n.exportCriterias }</legend>
            <Grid2 container spacing={1} alignItems='center'>
                <Grid2 size={2}>
                    <Input
                        title={ i18n.defineDirectory }
                        value={ tmpFilter.exportDir }
                        onChange={ v => onChangeFilter({ exportDir: v }) }
                    />
                </Grid2>
                <Grid2 size={2}>
                    <SimpleDatePicker
                        value={ tmpFilter.startDate }
                        label={ i18n.startDate }
                        onChange={ v => onChangeFilter({ startDate: v }) }
                    />
                </Grid2>
                <Grid2 size={2}>
                    <SimpleDatePicker
                        value={ tmpFilter.endDate }
                        label={ i18n.endDate }
                        onChange={ v => onChangeFilter({ endDate: v }) }
                    />
                </Grid2>
                <Grid2 size={3}>
                    <ButtonMUI
                        style={{ width: '100%' }}
                        onClick={ () => onChange({ selectStationIsOpen: true }) }
                    >{ `${i18n.selectStations} (${selectedStations.length})` }</ButtonMUI>
                </Grid2>
                <Grid2 size={3}>
                    <ButtonMUI
                        fullWidth
                        onClick={ onApplyExport }
                    >{ i18n.apply }</ButtonMUI>
                </Grid2>
            </Grid2>
        </fieldset>
    )
}


CEMAGREF_ExportPanel.propTypes = {
    onChange: PropTypes.func,
    onChangeFilter: PropTypes.func,
    selectedStations: PropTypes.arrayOf(PropTypes.instanceOf(DtoStation)),
    tmpFilter: PropTypes.shape({
        startDate: PropTypes.number,
        endDate: PropTypes.number,
    }),
    onApplyExport: PropTypes.func,
}

export default CEMAGREF_ExportPanel
